import { messages } from "../lib/messages";
import { FullScreenMessage } from "./FullScreenMessage";

/** BootstrapErrorScreen — прочие сбои бутстрапа (не shop_unavailable, не обрыв связи). */
export function BootstrapErrorScreen({ onRetry }: { onRetry: () => void }) {
  return (
    <FullScreenMessage
      testId="shop-bootstrap-error"
      title={messages.requestFailed}
      action={
        <button
          type="button"
          onClick={onRetry}
          className="rounded-card bg-button px-6 py-3 font-medium text-button-text"
        >
          {messages.retry}
        </button>
      }
    />
  );
}
